import apiFetch from '../apiFetch'

export default function (list, token) {
  return apiFetch({endPoint: `Informes/eliminarDosisEnvasadasSeleccion`, method: 'POST', body: {list}, token: token})
}